import { Badge, IconButton, useTheme } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  isOpen: boolean;
  onClick: () => void;
  activeFilterCount?: number;
};

export const FiltersTrigger = ({
  isOpen,
  onClick,
  activeFilterCount = 0,
}: Props) => {
  const { t } = useResource();
  const { palette } = useTheme();

  return (
    <Badge
      badgeContent={activeFilterCount}
      color="error"
      overlap="circular"
      invisible={activeFilterCount === 0}
      sx={{
        "& .MuiBadge-badge": {
          fontSize: 10,
          height: 18,
          minWidth: 18,
        },
      }}
    >
      <IconButton
        onClick={onClick}
        sx={{
          backgroundColor: palette.primary.main,
          color: palette.common.white,
          borderRadius: "50%",
          width: 40,
          height: 40,
          "&:hover": {
            backgroundColor: palette.primary.dark,
          },
        }}
        aria-label={t(RESOURCES.Title)}
        aria-expanded={isOpen}
      >
        <FilterListIcon />
      </IconButton>
    </Badge>
  );
};
